<template>
    <div class="land-section" v-if="landArr != null" id="menu-link-land">
        <div class="container">
            <sectionTitle :options="[{ title : landArr.land_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: landArr.land_quote_img, title : landArr.land_quote_title, desc: landArr.land_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : landArr.land_desc_left, desc_right: landArr.land_desc_right}]" class="section-desc-column-city-land"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: landArr.land_cards[0].images}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <landImagesGrid :options="[{ cards: landArr.land_cards, grid_img : landArr.land_img}]" class="land-images-grid-mix"></landImagesGrid>
            <!-- <sectionDescColumn :options="[{ desc_left : landArr.gingo_desc_left, desc_right: landArr.gingo_desc_right}]" class="section-desc-column-ginkgo"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: landArr.gingo_cards[0].images}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <landImagesGrid :options="[{ cards: landArr.gingo_cards, grid_img : landArr.gingo_img}]" class="land-images-grid-gingo"></landImagesGrid>
            <sectionDescColumn :options="[{ desc_left : landArr.fountain_desc_left, desc_right: landArr.fountain_desc_right}]" class="section-desc-column-land-fountain"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: landArr.fountain_cards[0].images}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <landImagesGrid :options="[{ cards: landArr.fountain_cards, grid_img : landArr.fountain_img}]"></landImagesGrid> -->
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import landImagesGrid from '@/components/landscaping/land-images-grid.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'land-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            landArr: 'loadLandArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            landImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/landscaping/land-section.scss';
    @import '@/styles/components/landscaping/respond/land-section-respond.scss';
</style>